import { useState, useEffect, useRef } from 'react';
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { formatDate } from '../../utils/helpers';

const DatePicker = ({
  selectedDate,
  onSelect,
  right = false
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);

  const handleSelect = (date) => {
    setShowCalendar(false);
    onSelect(date)
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div ref={calendarRef}>
        <button
          onClick={() => setShowCalendar(!showCalendar)}
          className='datepicker__btn'
        >
          {formatDate(selectedDate) ?? 0}
        </button>

        <div className={'absolute z-[100] calendar' + (showCalendar ? ' calendar-open' : '') + (right ? ' right-0 md:right-auto' : '')}>
          <div className='datepicker__calendar'>
            <Calendar
              color='#6366F1'
              date={selectedDate}
              onChange={handleSelect}
              className='!flex'
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DatePicker;
